module.exports = __webpack_public_path__ + "static/media/add-logo-mobile-en.12d509c4.png";